import * as globals from '@wandb/common/css/globals.styles';
import {TargetBlank} from '@wandb/common/util/links';
import styled from 'styled-components';

export const SearchNav = styled.div<{showAdminBanner?: boolean}>`
  background: ${props =>
    props.showAdminBanner ? globals.GOLD_DARK3 : globals.gray900};
  color: ${props => (props.showAdminBanner ? globals.WHITE : globals.gray500)}; 
  position: relative;
  overflow: hidden;
  align-items: center;
  }
`;

export const SearchNavLeft = styled.div<{showAdminBanner?: boolean}>`
    opacity: ${props => (props.showAdminBanner ? 0.5 : 1)};    
    &:hover {
      opacity: ${props => (props.showAdminBanner ? 0.8 : 1)};   
      color: white;
      }
  }
`;

export const ExperimentalTestBar = styled.div<{showAdminBanner?: boolean}>`
  position: absolute;
  top: 0;
  left: 86px;
  right: 146px;
  z-index: 1;
  min-height: 1px;
  background-color: ${props =>
    props.showAdminBanner ? globals.GOLD_DARK3 : globals.gray900};
`;
export const OpenPageLink = styled(TargetBlank)`
  align-items: center;
  display: flex;
  cursor: pointer;
  color: ${globals.gray800} !important;
  height: 100%;

  &&&:hover {
    color: ${globals.primaryText} !important;
  }
`;
